import '../index.css';

import { useCallback, useEffect, useState } from 'react';
import { Loader } from '../components/Loader';
import { WebGLBackdrop } from '../components/WebGLBackdrop';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Marquee } from '../components/Marquee';
import { Services } from '../components/Services';
import { Work } from '../components/Work';
import { Process } from '../components/Process';
import { Studio } from '../components/Studio';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
import { ReadyContext } from '../lib/ready';
import { startSmoothScroll, stopSmoothScroll } from '../lib/scroll';
import { sceneState } from '../three/state';

export function App() {
  const [ready, setReady] = useState(false);

  // Always open on the hero so the reveal lands where it was choreographed.
  useEffect(() => {
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    window.scrollTo(0, 0);
    document.documentElement.classList.add('is-loading');
    return () => stopSmoothScroll();
  }, []);

  const onReveal = useCallback(() => {
    document.documentElement.classList.remove('is-loading');
    sceneState.revealed = true;
    startSmoothScroll();
    setReady(true);
  }, []);

  return (
    <ReadyContext.Provider value={ready}>
      <div className="relative min-h-[100dvh] bg-base font-sans text-fg">
        <Loader onReveal={onReveal} />
        <WebGLBackdrop />
        <div className="grain" aria-hidden />
        <Navbar />
        <main className="relative z-10">
          <Hero />
          <Marquee />
          <Services />
          {/* <Work /> */}
          <Process />
          <Studio />
          <Contact />
        </main>
        <div className="relative z-10">
          <Footer />
        </div>
      </div>
    </ReadyContext.Provider>
  );
}

export default App;
